import { Component, OnInit } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { CustomerTenderService } from '../../../services/customer-tenders.service';
import { EventDetailService } from '../../../services/procurement-tender-event-details.service';
import { TenderPaymentModal } from '../../../modals/tender-payemnt-modal/tender-payment.component';
import { DocumentService } from '../../../services/document.service';
import { DomSanitizer } from '@angular/platform-browser';
import { OrganizationBidderService } from '../../../services/organization-bidders.service';
import { PaymentReviewModal } from '../../../modals';
import { ActivatedRoute } from '@angular/router';
import { LoginModal } from '../../../modals/login-modal/login-modal.component';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-customer-tender-list',
  templateUrl: './customer-tender-list.component.html',
  styleUrls: ['./customer-tender-list.component.scss'],
})
export class CustomerTenderListComponent implements OnInit {
  log(value: any) {
    console.log(value);
  }
  filter: AppFilter = new AppFilter();
  pendingArr: boolean[] = [];
  tenderParams: AppFilter;
  bidderId: string;
  listItems!: any[];
  listItemIdMap!: Record<string, object>;
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;

  maxSize: number = 7;
  projects: Array<any>;
  error: any;
  success: any;
  bidderParams: AppFilter;
  searchfilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'bidder.bidderId',
        op: 'eq',
        data: '',
      },
      {
        field: 'isShortlisted',
        op: 'eq',
        data: true,
      },
    ],
  };

  tab: 'award' | 'contract' = 'award';
  showLotList = false;
  showDetail = false;
  eventDetails;
  lotDetails;
  categories = [];
  tenderTypes = [];
  lotViewDetails;
  liveTime: any = '0 D : 0 H : 0 M : 0 S';
  interval: any;
  time: string = 'active';

  constructor(
    private modalService: SuiModalService,
    private customerTenderService: CustomerTenderService,
    private eventDetailService: EventDetailService,
    private documentService: DocumentService,
    private sanitizer: DomSanitizer,
    private organizationBidderService: OrganizationBidderService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      const message = params['message'];
      if (message) {
        if (message === 'success') {
          this.success = 'Payment made, please wait for confirmation!';
        } else this.error = 'Could not make payment, please try again!';
      }
    });

    this.bidderId = JSON.parse(localStorage.getItem('BIDDER_ID'));
    this.tenderParams = new AppFilter({
      page: 1,
      rows: 10,
      _search: false,
      sord: 'desc',
      sidx: 'publishStartDate',
      filters: JSON.stringify({
        groupOp: 'AND',
        rules: [],
      }),
    });
    this.bidderParams = new AppFilter({
      page: 1,
      rows: 1000,
      sidx: 'dateCreated',
      filters: JSON.stringify({
        groupOp: 'AND',
        rules: [
          {
            field: 'bidder.bidderId',
            op: 'cn',
            data: this.bidderId,
          },
          // {
          //   field: 'isShortlisted',
          //   op: 'eq',
          //   data: true,
          // },
        ],
      }),
    });

    this.getListItems();
    this.getAllCustomerTenders(this.currentPage);
    this.fetchCategories();
    this.fetchTenders();
  }

  getDataDiff(startDate, endDate) {
    var diff = endDate.getTime() - startDate.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
    var minutes =
      Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
    var seconds =
      Math.floor(diff / 1000) -
      (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
    return { day: days, hour: hours, minute: minutes, second: seconds };
  }

  getLiveTime(tender: any): any {
    this.liveTime = this.getDataDiff(
      new Date(Date.now()),
      new Date(tender.publishEndDate || tender.endDate)
    );

    let openingDate = this.getDataDiff(
      new Date(tender.publishStartDate || tender.startDate),
      new Date(Date.now())
    );

    if (openingDate.day < 0) {
      clearInterval(tender.liveTimeInterval);
      tender.time = 'not_started';
      return (tender.liveTime = 'NOT STARTED');
    }

    if (this.liveTime.day < 0) {
      clearInterval(tender.liveTimeInterval);
      tender.time = 'elapsed';
      return (tender.liveTime = 'ELAPSED');
    }

    tender.time = 'active';

    return (tender.liveTime = `${this.liveTime.day} D : ${this.liveTime.hour} H : ${this.liveTime.minute} M : ${this.liveTime.second} S`);
  }

  viewLotList() {
    this.showLotList = true;
    this.showDetail = false;
  }

  viewDetail(eventDetail) {
    this.showDetail = true;
    this.showLotList = false;
    this.lotDetails = eventDetail;
  }

  sanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  async viewLotDetail(lotDetail: any): Promise<any> {
    // if (
    //   !lotDetail.instructionsDocument &&
    //   !lotDetail.requiredTenderDocuments.length
    // ) {
    //   return (this.error = 'No documents found for this tender!');
    // }
    // Get instructions and required tender documents
    const requests = [];
    if (
      !(
        lotDetail?.requiredTenderDocuments?.length &&
        typeof lotDetail?.requiredTenderDocuments[0] !== 'string'
      )
    ) {
      requests.push(this.getProcDocRequiredDocument(lotDetail));
      this.lotViewDetails = lotDetail;
    }
    if (
      !(
        lotDetail.instructionsDocument &&
        typeof lotDetail.instructionsDocument !== 'string'
      )
    ) {
      requests.push(this.getProcDocInstruction(lotDetail.instructionsDocument));
    }

    // Make requests
    const [requiredTenderDocuments, instructionsDocument] = await Promise.all(
      requests
    );

    if (requiredTenderDocuments) {
      lotDetail.requiredTenderDocuments = requiredTenderDocuments;
    }
    if (instructionsDocument) {
      lotDetail.instructionsDocument = instructionsDocument;
      if (instructionsDocument[0]?.documentPath) {
        lotDetail.iframeUrl = this.sanitizeUrl(
          `${this.procurementUrl}/public/media/?media=${instructionsDocument[0]?.documentPath}`
        );
      } else if (
        instructionsDocument[0]?.optionId &&
        instructionsDocument[0]?.documentPath === null
      ) {
        const doc = await this.viewDocumentInFrame(instructionsDocument[0]);
        lotDetail.iframeUrl = this.sanitizeUrl(doc?.url);
        lotDetail.extension = doc.extension;
      }
    }
    this.lotViewDetails = lotDetail;
    this.showDetail = true;
    this.showLotList = false;
  }
  getProcDocRequiredTemplateDocument(proDoc: any) {
    const request = this.documentService.downloadTemplateProcurementDocument(
      proDoc.optionId
    );
    return request;
  }
  getProcDocRequiredDocument(proDoc: any) {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.documentService
        .getLotRequiredProcurementDocument({
          lotId: proDoc.lotId,
          biddingStageId: proDoc.biddingStageId,
        })
        .subscribe({
          next: (res: any[]) => {
            this.callCompleted();
            resolve(res);
          },
          error: () => {
            this.callCompleted();
            reject(undefined);
          },
        });
    });
  }
  getProcDocInstruction(procDocId: string) {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.documentService.getProcurementDocument({ procDocId }).subscribe({
        next: (res: any[]) => {
          this.callCompleted();
          resolve(res);
        },
        error: () => {
          this.callCompleted();
          reject(undefined);
        },
      });
    });
  }

  getProcCategories() {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.customerTenderService.getProcurementCategories().subscribe({
        next: (res: any[]) => {
          this.callCompleted();
          resolve(res);
        },
        error: () => {
          this.callCompleted();
          reject(undefined);
        },
      });
    });
  }
  fetchCategories(): void {
    this.getProcCategories()
      .then((category) => {
        this.categories = category;
      })
      .catch(() => {
        this.error = 'Failed to load category';
      });
  }
  fetchTenders(): void {
    this.getProcTenders()
      .then((tenders) => {
        this.tenderTypes = tenders;
      })
      .catch(() => {
        this.error = 'Failed to load tenders';
      });
  }
  getProcTenders() {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.customerTenderService.getProcurementTenderStages().subscribe({
        next: (res: any[]) => {
          this.callCompleted();
          resolve(res);
        },
        error: () => {
          this.callCompleted();
          reject(undefined);
        },
      });
    });
  }
  getRequiredTenderDocuments(tender: any) {
    return new Promise<any[]>((resolve, reject) => {
      if (!tender?.requiredTenderDocuments?.length) {
        resolve([]);
      }
      const filter = new AppFilter();
      filter.rows = 1000;
      filter.filters = JSON.stringify({
        groupOp: 'AND',
        rules: [
          {
            field: 'procDocId',
            op: 'in',
            data: tender?.requiredTenderDocuments.join(','),
          },
        ],
      });
      this.callStarted();
      this.documentService
        .getAllProcurementDocuments({ params: filter })
        .subscribe({
          next: (res: any[]) => {
            this.callCompleted();
            resolve(res['rows']);
          },
          error: () => {
            this.callCompleted();
            reject(undefined);
          },
        });
    });
  }

  getProcDoc(tender: any) {
    return new Promise<any>((resolve, reject) => {
      if (!tender?.requiredTenderDocuments?.length) {
        resolve([]);
      }
      this.callStarted();
      this.documentService
        .getProcurementDocument({
          procDocId: tender?.requiredTenderDocuments.join(','),
        })
        .subscribe({
          next: (res: any[]) => {
            this.callCompleted();
            resolve(res);
          },
          error: () => {
            this.callCompleted();
            reject(undefined);
          },
        });
    });
  }

  procurementUrl = environment.PROCUREMENT_API_SERVER;
  async downloadDocument(doc: any) {
    if (doc?.document?.documentPath) {
      const fileUrl = `${this.procurementUrl}/public/media/?media=${doc?.document?.documentPath}`;
      this.callStarted();
      this.http
        .get(fileUrl, { responseType: 'blob', observe: 'response' })
        .subscribe(
          (response) => {
            this.callCompleted();
            const blob = response.body;
            // Check the MIME type from the Blob or headers
            const contentType =
              blob.type || response.headers.get('Content-Type') || '';

            if (contentType === 'application/pdf') {
              // Open PDFs in a new tab
              const url = window.URL.createObjectURL(blob);
              window.open(url, '_blank');
            } else {
              // For other file types, try to get the filename from the Content-Disposition header
              let fileName = 'download';
              const contentDisposition = response.headers.get(
                'content-disposition'
              );
              if (contentDisposition) {
                const matches = /filename="([^"]+)"/.exec(contentDisposition);
                if (matches && matches[1]) {
                  fileName = matches[1];
                }
              } else {
                fileName = this.extractFileNameFromMediaParam(fileUrl);
              }

              // Create a temporary link and trigger a download
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }
          },
          (error: any) => {
            this.callCompleted();
            this.error = error?.error || 'Document download unsuccessful';
          }
        );
    } else {
      const { url } = await this.viewDocumentInFrame(doc);
      window.open(url, '_blank');
    }
  }

  private extractFileNameFromMediaParam(fileUrl: string): string {
    try {
      const url = new URL(fileUrl);
      const mediaParam = url.searchParams.get('media');
      if (mediaParam) {
        const uploadIndex = mediaParam.indexOf('upload_');
        if (uploadIndex !== -1) {
          // Extract the portion starting at "upload_"
          const filePart = mediaParam.substring(uploadIndex);
          // Expected format: "upload_<randomUUID>_fileName.extension"
          const parts = filePart.split('_');
          if (parts.length >= 3) {
            // Remove "upload" and the random UUID, then rejoin the remainder as the file name
            return parts.slice(2).join('_');
          }
        }
      }
    } catch (error) {
      console.error('Error extracting filename from media param:', error);
    }
    return 'download';
  }

  viewDocumentInFrame(
    document: any
  ): Promise<{ url: string; extension: string } | undefined> {
    return new Promise((resolve, reject) => {
      this.callStarted();
      const isUploaded = document?.document ? true : false;
      this.documentService
        .getFileBlob(
          isUploaded
            ? document.document.documentId
            : document?.optionId || document?.procDocId,
          isUploaded
        )
        .subscribe({
          next: (res: { blob: Blob; extension: string }) => {
            this.callCompleted();
            const url = window.URL.createObjectURL(res.blob);
            resolve({ url, extension: res.extension });
          },
          error: () => {
            this.callCompleted();
            reject(undefined);
          },
        });
    });
  }
  getProcDocTemplateInstruction(procDocId: string) {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.documentService
        .downloadTemplateProcurementDocument(procDocId, 'pdf')
        .subscribe({
          next: (res: any) => {
            let blob: Blob;
            let extension: string = 'pdf';

            if (res instanceof Blob) {
              blob = res;
            } else if (res.blob instanceof Blob) {
              blob = res.blob;
              extension = res.extension || extension;
            } else {
              console.error('Unexpected response format:', res);
              this.callCompleted();
              reject(new Error('Unexpected response format'));
              return;
            }
            const url = window.URL.createObjectURL(blob);
            resolve({ url, extension });
          },
          error: (error) => {
            console.error('Error downloading template:', error);
            if (error?.error instanceof Blob) {
              // Sometimes errors might contain the file as well
              const url = window.URL.createObjectURL(error.error);
              resolve({ url, extension: 'pdf' });
            } else {
              this.callCompleted();
              reject(error);
            }
          },
        });
    });
  }
  async pay(tender: any) {
    try {
      let eventDetails = tender?.eventDetails;
      if (!eventDetails) {
        const eventDetails = await this.createEventDetails(tender);
        if (eventDetails) {
          tender.eventDetails = eventDetails;
        } else return;
      }
      if (!eventDetails?.paymentId) await this.getPaymentStatus(tender);
      if (eventDetails?.paymentId) {
        tender.isInitiated = true;
        tender.paymentResponse = eventDetails?.paymentId;
      }
    } catch (error) {}
    if (!tender.eventDetails) return;
    if (!tender?.isInitiated) {
      this.makeTenderPayment(tender?.eventDetails);
    } else {
      if (tender?.paymentResponse?.status.toLowerCase() === 'paid') {
        this.modalService
          .open(
            new LoginModal(
              'Indicate Bid Participant Details',
              'tender.eventDetails',
              ModalSize.Tiny
            )
          )
          .onApprove(() => {
            this.getAllEventDetails(this.currentPage);
          })
          .onDeny(() => {});
      } else {
        this.tenderPaymentPreview(tender);
      }
    }
  }

  getPaymentStatus(tender: any) {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.organizationBidderService
        .getpaymentStatus({
          lotId: tender?.lotId,
          biddingStageId: tender?.biddingStageId,
          bidderId: this.bidderId,
        })
        .subscribe(
          (res) => {
            this.callCompleted();
            tender.paymentResponse = res;
            tender.isInitiated = true;
            resolve(undefined);
          },
          (error: any) => {
            this.callCompleted();
            tender.isInitiated = false;
            reject(error);
          }
        );
    });
  }
  getProcurementDocumentTenders(procDocId: string) {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.documentService
        .generateProcDocDocument({
          procDocId: procDocId,
          body: {},
        })
        .subscribe(
          (res) => {
            this.callCompleted();
            resolve(undefined);
          },
          (error: any) => {
            this.callCompleted();
            reject(error);
          }
        );
    });
  }

  makeTenderPayment(tenderEventDetails: any) {
    this.modalService.open(
      new TenderPaymentModal(
        'Make Tender Fee Payment',
        tenderEventDetails,
        ModalSize.Tiny
      )
    );
  }

  tenderPaymentPreview(tender: any) {
    this.modalService
      .open(
        new PaymentReviewModal(
          'Make Tender Fee Payment',
          tender?.paymentResponse,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  onCheckboxChange(event: Event, category: string) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        // {
        //   field: 'requiredProcCategory',
        //   op: 'cn',
        //   data: '',
        // },
      ],
    };

    const categories = [];
    const tenders = [];

    document.querySelectorAll('.category').forEach((element: any, index) => {
      if (element.checked) {
        categories.push(this.categories[index - 1].optionName.toLowerCase());
      }
    });
    document.querySelectorAll('.tenderType').forEach((element: any, index) => {
      if (element.checked) {
        tenders.push(this.tenderTypes[index].biddingStageName.toLowerCase());
      }
    });

    if (tenders.length) {
      tenders.forEach((tender) => {
        searchFilter.rules.push({
          field: 'biddingStageName',
          op: 'eq',
          data: tender,
        });
      });
    } else {
      searchFilter.rules.push({
        field: 'biddingStageName',
        op: 'eq',
        data: '',
      });
    }

    if (categories.length) {
      categories.forEach((category) => {
        searchFilter.rules.push({
          field: 'requiredProcCategory',
          op: 'eq',
          data: category,
        });
      });
    } else {
      searchFilter.rules.push({
        field: 'requiredProcCategory',
        op: 'eq',
        data: '',
      });
    }

    if (!categories.length && !tenders.length) {
      searchFilter.rules.push({
        field: 'requiredProcCategory',
        op: 'cn',
        data: '',
      });
      searchFilter.rules.push({
        field: 'biddingStageName',
        op: 'cn',
        data: '',
      });
    }

    this.tenderParams._search = true;
    this.tenderParams.filters = JSON.stringify(searchFilter);
    this.getAllCustomerTenders(this.currentPage);
  }

  getAllCustomerTenders(page) {
    this.callStarted();
    this.tenderParams.page = page;
    this.customerTenderService
      .getAllCustomerTenders({
        params: this.tenderParams,
      })
      .subscribe(
        (res) => {
          this.totalItems = res.records;
          this.rows = this.tenderParams.rows;
          this.currentPage = this.tenderParams.page;
          this.callCompleted();
          this.projects = res['rows'];
          this.projects.forEach((project) => {
            project.liveTime = setInterval(
              () => this.getLiveTime(project),
              1000
            );
          });
          this.joinEventDetailsWithTenderView();
        },
        (error) => {
          this.error = error.error ? error.error : error;
          this.callCompleted();
        }
      );
  }

  getAllEventDetails(page) {
    this.callStarted();
    this.bidderParams.page = page;
    this.eventDetailService
      .getAllEventDetails({
        params: this.bidderParams,
      })
      .subscribe(
        (res) => {
          this.callCompleted();
          this.eventDetails = res['rows'];
          this.joinEventDetailsWithTenderView();
        },
        (error) => {
          this.error = error.error ? error.error : error;
          this.callCompleted();
        }
      );
  }

  async createEventDetails(tender: any) {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.eventDetailService
        .createEventDetails({
          lotId: tender.lotId,
          biddingStageId: tender.biddingStageId,
          bidderId: this.bidderId,
          body: { bidderId: this.bidderId },
        })
        .subscribe(
          async () => {
            this.callCompleted();
            const eventDetails = await this.getEventDetails(tender);
            resolve(eventDetails);
          },
          (error) => {
            this.error = error.error ? error.error : error;
            this.callCompleted();
            reject(undefined);
          }
        );
    });
  }

  async getEventDetails(tender: any) {
    return new Promise<any>((resolve, reject) => {
      this.callStarted();
      this.eventDetailService
        .getEventDetail({
          lotId: tender.lotId,
          biddingStageId: tender.biddingStageId,
          bidderId: this.bidderId,
        })
        .subscribe(
          (res: any) => {
            this.callCompleted();
            resolve(res);
          },
          (error) => {
            reject(undefined);
            this.error = error.error ? error.error : error;
            this.callCompleted();
          }
        );
    });
  }

  joinEventDetailsWithTenderView() {
    if (this.projects && this.eventDetails) {
      const lotBiddingStageIdMap: any = {};
      this.eventDetails.forEach((tender: any) => {
        lotBiddingStageIdMap[tender.lotId + tender.biddingStageId] = tender;
      });
      this.projects.forEach((tender) => {
        if (lotBiddingStageIdMap[tender.lotId + tender.biddingStageId]) {
          tender.eventDetails =
            lotBiddingStageIdMap[tender.lotId + tender.biddingStageId];
        }
      });
    }
  }

  deleteLot(eventDetail) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove Lot',
          'Are you sure you want to remove this lot?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.removeItemFromList(eventDetail);
      })
      .onDeny(() => {});
  }

  deleteTenderLot(eventDetail) {
    this.callStarted();
    this.eventDetailService
      .deleteEventDetails({
        lotId: eventDetail.lotId,
        bidderId: eventDetail.bidderId,
        biddingStageId: eventDetail.biddingStageId,
      })
      .subscribe(
        (res) => {
          this.callCompleted();
          this.getAllCustomerTenders(this.currentPage);
          this.getAllEventDetails(this.currentPage);
        },
        (error) => {
          this.error = error.error ? error.error : error;
          this.callCompleted();
        }
      );
  }

  printSlip(event: any) {
    this.modalService
      .open(
        new LoginModal(
          'Indicate Bid Participant Details',
          event,
          ModalSize.Tiny
        )
      )
  }

  enterNumber() {
    this.modalService
      .open(
        new TenderPaymentModal(
          'Make Tender Fee Payment',
          this.lotDetails,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  itemIsInList(item: any) {
    const id = item?.lotId + item?.biddingStageId;
    return this.listItemIdMap[id];
  }

  async addItemToList(item: any) {
    // if (!item?.eventDetails) {
    //   item.eventDetails = await this.createEventDetails(item);
    // }

    if (item?.lotId && item?.biddingStageId) {
      const id = item?.lotId + item?.biddingStageId;
      if (!this.listItemIdMap[id]) {
        this.listItems.push(item);
        this.listItemIdMap[id] = item;
        this.saveUpdatedListItems();
      }
    } else {
      this.error = 'Failed to add to list';
    }
  }

  confirmRemove(item: any) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove Lot',
          'Are you sure you want to remove this lot?',
          ModalSize.Mini,
          'Yes',
          'Cancel'
        )
      )
      .onApprove(() => this.removeItemFromList(item));
  }

  removeItemFromList(item: any) {
    delete this.listItemIdMap[item.lotId + item.biddingStageId];
    this.listItems = this.listItems.filter((listItem) => {
      return !(
        item?.lotId == listItem?.lotId &&
        item?.biddingStageId == listItem?.biddingStageId
      );
    });
    this.saveUpdatedListItems();
  }

  getListItems() {
    this.listItems = JSON.parse(localStorage.getItem('listItems') || '[]');
    this.listItemIdMap = JSON.parse(
      localStorage.getItem('listItemIdMap') || '{}'
    );
  }

  saveUpdatedListItems() {
    localStorage.setItem('listItems', JSON.stringify(this.listItems));
    localStorage.setItem('listItemIdMap', JSON.stringify(this.listItemIdMap));
  }

  selectColor(status): string {
    status = status ? status?.toLowerCase() : '';
    switch (status) {
      case 'paid':
        return '#47C672';
      case 'unpaid':
        return 'red';
      case 'free':
        return '#4691EA';
      default:
        return '#BFBFBF';
    }
  }

  isPreviewAvailable(doc: any): boolean {
    if (!doc) return false;
    const ext = (doc.extension || '').toLowerCase();
    // Acceptable extensions for preview
    const validExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'gif'];
    return validExtensions.includes(ext);
  }

  goBack() {}
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'lotName',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    this.tenderParams._search = true;
    this.tenderParams.filters = JSON.stringify(searchFilter);
    this.getAllCustomerTenders(this.currentPage);
  }
  displayRecords(value) {
    this.tenderParams.rows = value;
    this.nextPage(1);
    this.getAllCustomerTenders(this.currentPage);
  }
  sortRecords(value) {
    this.tenderParams.sord = value;
    this.getAllCustomerTenders(this.currentPage);
  }
  nextPage(value) {
    this.tenderParams.page = value;
    this.currentPage = value;
    this.getAllCustomerTenders(this.currentPage);
  }
  viewProject(event) {}
  ngOnInit(): void {}

  callStarted() {
    this.pendingArr.push(true);
  }

  callCompleted() {
    this.pendingArr.pop();
  }
}
